import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

export const themesService = {
    getAll,
};

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/reviews/themes`, requestOptions).then(handleResponse);
}
